<div class="log-container" [class.blur]="isBlurred">

  <div class="p-button-bar">
    <p-button id="logIcon" styleClass="p-button-raised" label="{{label}}" badge="{{outputLines.length}}"
      icon="pi {{icon}}" (click)="active()"></p-button>
    <p-button styleClass="p-button-raised" label="Delete" icon="pi pi-trash" (click)="clearOutput()"></p-button>
  </div>

  <div class="log">
    <div class="tal-output-widget-pscroll">
      <div class="content-api" *ngFor="let line of outputLines">
        <div id="flash-div-{{line.id}}" class="log-line flash-div">
          <div class="row-icon">
            <i id="icon-{{line.id}}" pTooltip="Copied" tooltipPosition="left" [life]="1000" tooltipEvent="focus"
              class="pi pi-copy" (click)="copy(line.id)"></i>
          </div>
          <div class="log-text">
            <i style="vertical-align: middle;" class="pi pi-angle-right"></i>{{line.content}}
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
